import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

// Get saved language from localStorage or default to 'en'
const getSavedLanguage = (): string | null => {
  try {
    const saved = localStorage.getItem('selected_language')
    return saved || null
  } catch {
    return null
  }
}

const savedLanguage = getSavedLanguage()

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: savedLanguage || undefined,
    resources: {
      en: {
        translations: {
          already_have_an_account: 'Already have an account?',
          remember_me: 'Remember Me',
          forgot_password: 'Forgot Password',
          sign_in_with_otp: 'Sign in with OTP',
          email_address: 'Email Address',
          signup: 'Signup',
          login: 'Login',
          set_new_password: 'Set New Password',
          set_new_password_description: 'Your new password must be different from previously used passwords',
          security_info_text: 'Use at least 8 characters with a mix of letters, numbers & symbols',
          back_to_login: 'Back to Login',
          new_password: 'New Password',
          confirm_password: 'Confirm Password',
          welcome_heading: 'Hello Everyone, We are Meetzy',
          welcome_desc: 'Welcome to Meetzy, please',
          enter_email_address: "Enter your email address and we'll send you a link to reset your password.",
          password: 'Password',
          enter_name: 'Enter your name',
          enter_email: 'Enter your Email',
          enter_password: 'Enter your Password',
          verify_otp: 'Verify OTP',
          sent_otp: "We've sent a verification code to ",
          didnt_receive_otp: "Didn't receive the OTP",
          back_to_forgot_password: 'Back to Forgot Password',
          user_name: 'User Name',
          full_name: 'Full Name',
          phone_number: 'Phone Number',
          type_a_number: 'Enter your number',
          reset_password: 'Reset Password',
          find_friends_desc: 'People You May Know',
          find_friends: 'Find Friends',
          notifications: 'Notifications',
          manage_your_notifications: 'Manage your friend requests and notifications',
          no_notifications: 'No Notifications',
          no_notifications_desc: "You don't have any notifications at the moment",
          accept: 'Accept',
          reject: 'Reject',
          accepting: 'Accepting...',
          rejecting: 'Rejecting...',
          friend_request_accepted: 'Friend request accepted successfully',
          friend_request_rejected: 'Friend request rejected',
          notification_deleted: 'Notification deleted',
          delete_notification: 'Delete notification',
          action_failed: 'Action failed',
          delete_failed: 'Failed to delete notification',
          load_more: 'Load More',
          just_now: 'Just now',
          chat_wallpaper: 'Chat Wallpaper',
          choose_color: 'Choose Color',
          customizer: 'Customizer',
          real_time_customize: 'Real Time Customize',
          configuration: 'Configuration',
          config_desc: 'To replace our design with your desired Template. Please do configuration as mention',
          cancel: 'Cancel',
          copy_text: 'Copy Text',
          email_or_phone: 'Email or Phone',
          enter_email_or_phone: 'Enter Email or Phone',
          back: 'Back',
          enter_otp: 'Enter OTP',
          verify_and_login: 'Verify & Login',
          start_without_delay: 'Start without delay',
          contact: 'Contact',
          share_resources: 'Shared Resources',
          files: 'Files',
          tailor_video_content: 'Tailor Video Content',
          video_title: 'Video Title',
          add_to_do: 'Add To Do',
          taskList: 'Task List',
          todo: 'To Do',
          blocked_users: 'Blocked Users',
          manage_blocked_users: "Manage users you've blocked",
          no_blocked_users: 'No Blocked Users',
          link_email: 'Link Email',
          no_blocked_users_desc:
            "You haven't blocked anyone yet. Blocked users won't be able to message or interact with you.",
          unblock: 'Unblock',
          block: 'Block',
          unblocking: 'Unblocking...',
          user_unblocked_successfully: 'User unblocked successfully',
          unblock_failed: 'Failed to unblock user',
          blocked_user_message: 'This user is blocked and cannot contact you',
          favorite: 'Favorite',
          liked_message: 'Liked Message...',
          search_favorites: 'Search favorites...',
          add_to_favorites: 'Add to Favorites',
          no_favorites: 'No Favorites Yet',
          no_favorites_desc: 'Add contacts or groups to your favorites for quick access',
          removed_from_favorites: 'Removed from favorites',
          remove_from_favorites: 'Unfavorite',
          unknown: 'Unknown',
          favorite_updated: 'Favorite updated successfully',
          favorite_update_failed: 'Failed to update favorite',
          add_contact: 'Add Contact',
          email_or_username: 'Email or Username',
          contact_number: 'Contact Number',
          adding: 'Adding...',
          please_enter_email_or_username: 'Please enter email or username',
          failed_to_add_contact: 'Failed to add contact',
          search_and_add_feature_coming_soon: 'Search and add feature coming soon',
          settings_title: 'Settings',
          settings_description: 'Manage your account settings',
          settings_loading: 'Loading...',
          settings_default_user: 'User',
          settings_no_location: 'No location set',
          settings_name_placeholder: 'Enter name',
          settings_country_placeholder: 'Enter location',
          settings_save: 'Save',
          settings_saving: 'Saving...',
          settings_edit_label: 'Edit profile',
          settings_save_label: 'Save profile',
          settings_name_label: 'Name',
          settings_country_label: 'Location',
          my_status: 'My Status',
          status_update: 'Tap to add status update',
          recent_updates: 'Recent Updates',
          viewed_updates: 'Viewed Updates',
          no_status: 'No Status',
          status_desc: 'No Status Updated',
          create_status: 'Create Status',
          avatar: 'Avatar',
          file_input: 'File input',
          select_image_or_video: 'Select Image or Video',
          file_size_limit: 'Max 10MB for images, 50MB for videos (30 seconds max)',
          preview: 'Preview',
          caption_optional: 'Caption (optional)',
          add_caption_placeholder: 'Add a caption...',
          change_file: 'Change File',
          upload_status: 'Upload Status',
          uploading: 'Uploading...',
          please_select_file: 'Please select a file',
          status_uploaded_success: 'Status uploaded successfully!',
          status_upload_failed: 'Failed to upload status',
          status_count: '{{count}} Status Update',
          status_count_plural: '{{count}} Status Updates',
          updates_count: '{{count}} updates',
          add_more_status: 'Add more status',
          close_panel: 'Close panel',
          you: 'You',
          add_caption: 'Add Caption',
          status: 'Status',
          archive_users: 'Archive Chat',
          manage_archive_users: 'Manage Archive Chat',
          no_archive_users: 'No archive users',
          no_archive_users_desc:
            "You haven't archive anyone yet. Archive users won't be able to message or interact with you.",
          user_unarchive_successfully: 'User Unarchive Successfully',
          unarchive_failed: 'Unarchive Failed',
          listing_of_records: 'Listing of records',
          document: 'Document',
          bio_data: 'Hey, I am having a nice day.',
          account_title: 'Account',
          last_seen: 'Last Seen',
          profile_pic: 'Profile Pic',
          display_bio: 'Display Bio',
          user_status: 'User Status',
          read_receipts: 'Read Receipts',
          typing_indicator: 'Typing Indicator',
          auto_backup: 'Auto Backup (only text)',
          doc_backup: 'Include document',
          video_backup: 'Include video',
          create_new_group: 'Create New Group',
          group_name: 'Group name',
          enter_group_name: 'Enter group name',
          description: 'Description',
          describe_the_group_optional: 'Describe the group (optional)',
          group_avatar: 'Group avatar',
          select_members: 'Select members',
          selected_count: '{{count}} selected',
          search_by_name_or_email: 'Search by name or email',
          no_contacts_found: 'No contacts found',
          loading_contacts: 'Loading contacts...',
          create_group: 'Create group',
          group_name_required: 'Group name is required',
          group_created_successfully: 'Group created successfully.',
          failed_to_create_group: 'Failed to create group',
          start_new_chat: 'Start Chat',
          start_new_call: 'Start New Call',
          search_anything: 'Search Anything',
          no_messages_found: 'No Messages Found',
          add_members: 'Add Members',
          search_contacts: 'Search contacts...',
          loading: 'Loading...',
          about: 'About',
          members: 'Members',
          settings: 'Settings',
          add_member: 'Add Member',
          only_admins_can_access_settings: 'Only admins can access settings.',
          image_size_limit: 'Image size must be less than 5MB',
          group_updated_successfully: 'Group updated successfully',
          failed_to_update_group: 'Failed to update group',
          members_added_successfully: 'Members added successfully',
          failed_to_add_members: 'Failed to add members',
          member_removed_successfully: 'Member removed successfully',
          failed_to_remove_member: 'Failed to remove member',
          member_role_updated: 'Member role updated to {{role}}',
          failed_to_update_member_role: 'Failed to update member role',
          confirm_leave_group: 'Are you sure you want to leave this group?',
          left_group_successfully: 'You have left the group',
          failed_to_leave_group: 'Failed to leave group',
          no_description: 'No description',
          edit: 'Edit',
          save: 'Save',
          created_by: 'Created by',
          on: 'on',
          unknown_date: 'Unknown date',
          leave_group: 'Leave Group',
          leave_group_desc: 'You will no longer have access to this group.',
          enter_group_description: 'Enter group description',
          search_members: 'Search members...',
          me: 'ME',
          admin: 'Admin',
          make_admin: 'Make admin',
          remove_admin: 'Remove admin',
          remove_from_group: 'Remove from Group',
          customizers_title: 'Customizers',
          mute_chat: 'Mute Chat',
          mute_chat_description: 'Mute Chat Description',
          hour_1: '1 Hour',
          mute_for_1_hour: 'Mute for 1 hour',
          mute_for_8_hours: 'Mute for 8 hour',
          mute_for_1_week: 'Mute for 1 week',
          hours_8: '8 Hours',
          week_1: '1 Week',
          forever: 'Forever',
          mute_forever: 'Mute forever',
          chat_muted_for: 'Chat muted for',
          chat_unmuted: 'Chat unmuted',
          send_otp: 'Send OTP',
          login_with_phone: 'Login with Phone',
          email: 'Email',
          link_email_address: 'Link Email Address',
          link_phone_number: 'Link Phone Number',
          link_password: 'Link Password',
          leave_and_delete: 'Leave and delete',
          leave_and_delete_for_me: 'Leave and delete this group for me',
          leave_group_confirm_message:
            'Are you sure you want to leave this group? You can also delete this group for you.',
          delete_group_for_me: 'Delete Group for me',
          delete_group_for_me_desc: 'Delete this group only for me',
          chat_deleted_successfully: 'Chat deleted successfully',
          please_select_valid_image: 'Please select a valid image',
          svg_not_allowed: 'SVG files are not supported',
          failed_to_delete_group_for_me: 'Failed to delete',
          get_started: 'Get Started',
          learn_more: 'Learn More',
          create_new_broadcast: 'Create New Broadcast',
          create_broadcast: 'Create Broadcast',
          broadcast_name: 'Broadcast Name',
          broadcast_name_required: 'Broadcast name is required',
          enter_broadcast_name: 'Enter broadcast name',
          select_recipients: 'Select Recipients',
          at_least_one_recipient_required: 'At least one recipient is required',
          broadcast_created_successfully: 'Broadcast created successfully',
          failed_to_create_broadcast: 'Failed to create broadcast',
          delete_broadcast: 'Delete Broadcast',
          delete_broadcast_desc: 'Are you sure, you want to delete this broadcast?',
          forward: 'Forward',
          copy: 'Copy',
          copied: 'Copied',
          star: 'Star',
          pin: 'Pin',
          unpin: 'Unpin',
          delete: 'Delete',
          everyone: 'Everyone',
          contact_info: 'Contact info',
          view_profile: 'View Profile',
          select_message: 'Select Message',
          lock_chat: 'Lock Chat',
          unlock_chat: 'Unlock Chat',
          close_chat: 'Close Chat',
          clear_chat: 'Clear Chat',
          delete_chat: 'Delete Chat',
          disappearing_messages: 'Disappearing',
          report: 'Report',
          chats: 'Chats',
          call: 'Call',
          call_messages: 'Call Messages',
          archive: 'Archive',
          documents: 'Documents',
          friend_suggestions: 'Friend Suggestions',
          blocked_users_hint: 'Blocked Users',
          favorites_hint: 'Favorites',
          settings_hint: 'Settings',
          toggle_theme: 'Toggle Theme',
          logout_hint: 'Logout',
          help_support: 'Help & Support',
          dashboard: 'Dashboard',
          calendar: 'Calendar',
          write_your_message: 'Write your message...',
          edit_your_message: 'Edit your message...',
          reply_placeholder: 'Reply...',
          type_a_reply: 'Type a reply...',
          replying_to_yourself: 'Replying to yourself',
          replying_to: 'Replying to {{name}}',
          editing_message: 'Editing message',
          only_admin_can_send: 'Only Admin can send messages',
          only_admins: 'Only admins',
          clear_chat_confirmation: 'Clear Chat Confirmation',
          clear_chat_message: 'Are you sure you want to clear your chat?',
          delete_chat_message: 'Are you sure you want to delete this chat?',
          archive_all_chats: 'Archive All Chats',
          archive_all_chats_message:
            'Are you sure you want to archive all chats? This action will move all your chats to the archive.',
          clear_all_chats: 'Clear All Chats',
          clear_all_chats_message:
            'Are you sure you want to clear all chats? This action will remove all messages from all your chats. This action cannot be undone.',
          delete_all_chats: 'Delete All Chats',
          delete_all_chats_message:
            'Are you sure you want to delete all chats? This action will permanently delete all your chats. This action cannot be undone.',
          message_selected: '{{count}} Message selected',
          messages_selected: '{{count}} Messages selected',
          select_all: 'Select All',
          star_all: 'Star All',
          unstar_all: 'Unstar All',
          unstar: 'Unstar',
          toggle_star: 'Toggle Star',
          download_file: 'Download file',
          download_files: 'Download {{count}} files',
          confirm: 'Confirm',
          continue: 'Continue',
          retry: 'Retry',
          failed: 'Failed',
          typing: 'Typing...',
          messages: 'Messages',
          groups: 'Groups',
          contacts: 'Contacts',
          no_messages: 'No messages',
          no_chats: 'No chats',
          no_contacts: 'No contacts',
          no_groups: 'No groups',
          logout_confirmation: 'Logout Confirmation',
          logout_confirmation_message: 'Are you sure you want to logout?',
          logging_out: 'Logging out...',
          subscriptions: 'Subscriptions',
          manage_your_subscription: 'Manage your subscription',
          plans: 'Plans',
          document_verification: 'Document Verification',
          upload_verification_documents: 'Upload verification documents',
          view_and_manage_subscription: 'View and manage subscription plans',
          broadcast: 'Broadcast',
          toggle_recipient: 'Toggle {{name}}',
          turn_on_this_setting: 'Turn on this setting to whether your contact can see',
          or_not: 'or not.',
          action_cannot_be_undone: 'This action cannot be undone.',
          checking: 'Checking...',
          checking_internet_connection: 'Checking internet connection...',
          no_internet: 'No internet',
          make_sure_connected: 'Make sure you are connected to the internet and try again.',
          demo_message: 'Demo Message',
          this_is_demo_message: 'This is demo message',
          learn_more_link: 'Learn more',
          account_message: 'Account Message',
          chat_message: 'Chat Message',
          verified: 'verified',
          meetzy_verified: 'Meetzy verified',
          status_reply: 'Status',
          text_status: 'Text status',
          type_a_reply_status: 'Type a reply...',
          select_a_reason: 'Select a reason',
          please_provide_more_information: 'Please provide more information...',
          enter_your_full_name: 'Enter your full name',
          select_a_document_type: 'Select a document type',
          find_your_friends: 'Find Your Friends',
          find_friends_des: 'Search by name or contact details and find your friends in seconds.',
          new_chat: 'New Chat',
          new_call: 'New Call',
          new_group: 'New Group',
          new_broadcast: 'New Broadcast',
          select_a_chat_to_start_messaging: 'Select a chat to start messaging',
          choose_conversation: 'Choose a contact from the list to begin conversation',
          all: 'All',
          unread: 'Unread',
          favourite: 'Favourite',
          lockChat: 'Lock Chat',
          phone: 'Phone',
          dont_have_an_account: "Don't have an account?",
          login_with_OTP: 'Login with OTP',
          password_optional: 'Password (optional)',
          send_OTP: 'Send OTP',
          group_member_limit_exceeded: 'Group member limit exceeded',
          group_limit_reached: 'Group limit reached',
          broadcast_member_limit_exceeded: 'Broadcast member limit exceeded',
          broadcast_member_limit_reached: 'Broadcast member limit reached',
          group_member_limit_reached: 'Group member limit reached',
          broadcast_limit_reached: 'Broadcast limit reached',
          status_limit_reached: 'Status limit reached',
          status_remaining: 'Status remaining',
          chat: 'Chat',
          failed_to_stop_impersonation: 'Failed to stop impersonation',
          reset_pin: 'Reset PIN',
        },
      },
    },
    fallbackLng: 'en',
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
